import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import DefaultInput from "@View/components/formInputs/DefaultInput";
import DefaultMultipleRowInput from "@View/components/formInputs/DefaultMultipleRowInput";
import ModalLayout from "@View/components/ModalLayout";
import { downloadFile } from "@Dao/api";
import getAPI from "@API/index";
import FolderZipIcon from "@mui/icons-material/FolderZip";

const DocumentsSection = ({ lead }) => {
  const { t } = useTranslation();
  const [docCount, setDocCount] = useState(null);

  useEffect(() => {
    if (!lead?.id) return;
    setDocCount(null);
    getAPI()
      .request({ method: "get", url: `/api/lead/${lead.id}/documents` })
      .then((response) => {
        if (response?.data) setDocCount(response.data.length);
      });
  }, [lead?.id]);

  const hasDocuments = docCount !== null && docCount > 0;

  return (
    <div style={{ marginTop: 22, marginBottom: 20, position: "relative" }}>
      <span
        style={{
          position: "absolute",
          top: -25,
          fontWeight: 500,
          fontSize: 14,
          lineHeight: "17px",
          color: "#A1ADBA",
        }}
      >
        {t("inputs.Documents")}
      </span>
      <div
        style={{
          border: "1px solid #E1E6F1",
          borderRadius: 8,
          padding: "14px 15px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span style={{ fontWeight: 500, fontSize: 14, lineHeight: "17px", color: "#54606F" }}>
          {docCount === null
            ? "..."
            : docCount === 0
              ? t("inputs.NoDocuments")
              : `${docCount} ${t("inputs.DocumentsCount")}`}
        </span>
        {hasDocuments && (
          <div
            onClick={() => downloadFile(`/api/lead/${lead.id}/documents/download`)}
            style={{ cursor: "pointer", color: "#54606F", display: "flex", alignItems: "center" }}
            title={t("buttons.DownloadDocuments")}
          >
            <FolderZipIcon style={{ fontSize: 20 }} />
          </div>
        )}
      </div>
    </div>
  );
};

const LeadDetailsModal = ({ lead, open, handleClose }) => {
  const { t } = useTranslation();

  if (!lead) return null;

  return (
    <ModalLayout
      open={open}
      onClose={handleClose}
      title="h1.Details of"
      subtitle={lead.borrowerName}
    >
      <DefaultInput
        label="inputs.CompanyName"
        value={lead.borrowerName || ""}
        onChange={() => null}
      />
      <DefaultInput
        label="inputs.INN"
        value={lead.inn || ""}
        onChange={() => null}
      />
      <DefaultInput
        label="inputs.BorrowerEmail"
        value={lead.borrowerEmail || ""}
        onChange={() => null}
      />
      <DefaultInput
        label="inputs.RequestedAmount"
        value={lead.requestedAmount != null ? String(lead.requestedAmount) : ""}
        onChange={() => null}
      />
      <DefaultInput
        label="inputs.TermMonths"
        value={lead.requestedTermMonths != null ? String(lead.requestedTermMonths) : ""}
        onChange={() => null}
      />
      <DefaultInput
        label="inputs.Status"
        value={lead.status ? t(`LeadStatus.${lead.status}`) : ""}
        onChange={() => null}
      />
      <DefaultInput
        label="inputs.CreditProduct"
        value={lead.creditProduct || ""}
        onChange={() => null}
      />
      <DefaultInput
        label="inputs.ResponsibleEmployeeName"
        value={lead.responsibleEmployeeName || ""}
        onChange={() => null}
      />
      <DefaultInput
        label="inputs.ResponsibleEmployeePhone"
        value={lead.responsibleEmployeePhone || ""}
        onChange={() => null}
      />
      <DefaultInput
        label="inputs.CeoPhone"
        value={lead.ceoPhone || ""}
        onChange={() => null}
      />
      {/*
      <DefaultMultipleRowInput
        label="inputs.StopFactors"
        value={lead.stopFactors || ""}
        onChange={() => null}
        disabled
        rows={4}
      />
      */}
      <DocumentsSection lead={lead} />
    </ModalLayout>
  );
};

export default LeadDetailsModal;
